import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Dropdown, Input } from "antd";

import partnersApi from "../../apis/Partners.api";
import { setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";

const BankListComponent = ({ submitBank, setSubmitBank }) => {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [bankList, setBankList] = useState([]);
	const [selectedBank, setSelectedBank] = useState({
		code: null,
		name: null,
	}); // 선택한 은행
	const [account, setAccount] = useState(""); // 계좌번호

	useEffect(() => {
		getBankList();
	}, []);

	/**
	 * 포트원 은행 리스트 조회
	 * @returns {Promise<void>}
	 * [{
	 * code: 은행코드
	 * name: 은행명
	 * }]
	 */
	const getBankList = async () => {
		try {
			const res = await partnersApi.readBankList();
			if (res.code === 200) {
				let list = res.result;
				setBankList(list);
			}
		} catch (e) {
			console.log("e", e);
		}
	};

	const items =
		bankList?.length > 0
			? bankList?.map((item) => ({
					label: item.name,
					key: item.code,
			  }))
			: [];

	const onClick = ({ key }) => {
		let clickBank = bankList.filter((item) => item.code === key);
		if (clickBank?.[0]?.code) {
			setSelectedBank(clickBank?.[0] ?? { code: null, name: null });
			setSubmitBank({
				...submitBank,
				bank_code: clickBank[0].code,
			});
		}
	};

	const handleInputBank = (e) => {
		let value = e.target.value.replace(/[^0-9]/g, "");
		setAccount(value);
		setSubmitBank({
			...submitBank,
			account_number: value,
		});
	};

	/**
	 * 계좌정보 업데이트
	 * @returns {Promise<void>}
	 */
	// const onClickBankEdit = async () => {
	// 	setIsLoading(true);
	// 	let param = {
	// 		id: user.id,
	// 		key: "bank_account",
	// 		bank_code: selectedBank.code,
	// 		account_number: account,
	// 		is_app: false,
	// 	};
	// 	const res = await partnersApi.postPersonalBankAccount(param);
	// 	if (res.code === 200) {
	// 		setSubmitBank(res.result);
	//
	// 		// user 업데이트
	// 		const paramUser = {
	// 			type: "mallId",
	// 			userId: user.mall_id,
	// 		};
	// 		partnersApi.readMallPartnersId(paramUser).then((res) => {
	// 			if (res.code !== 400) {
	// 				dispatch(setUser(res.result));
	// 			}
	// 		});
	// 	}
	// 	setIsLoading(false);
	// };

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-start",
				width: "100%",
				gap: "1em",
			}}
		>
			<Dropdown
				menu={{
					items,
					onClick,
				}}
				trigger={["click"]}
				overlayStyle={{
					maxHeight: 200,
					overflow: "auto",
				}}
			>
				<Input
					loading={isLoading}
					placeholder={"은행을 선택해주세요"}
					value={selectedBank.name}
				/>
			</Dropdown>
			<Input
				placeholder={`-를 생략하고 입력해주세요`}
				disabled={isLoading}
				value={account}
				onChange={handleInputBank}
				pattern={`/d*`}
			/>
		</div>
	);
};

export default BankListComponent;
